import { useMemo } from "react"
import Table, { SelectColumnFilter } from "../../components/table/Table"
import DirectLink from "../../components/template/DirectLink"
import Spinner from "../../components/template/Spinner"

const ServiceArchiveTable = ({ data }) => {
    const columns = useMemo(
        () => [
            {
                Header: "ID",
                accessor: "id",
            },
            {
                Header: "Service Name",
                accessor: "name",
                Filter: SelectColumnFilter,
                filter: 'exactTo',
            },
            {
                Header: "Google Storage",
                accessor: "path",
                Cell: ({ row }) => (<>{
                    row.original.status === 1 ?
                        <DirectLink path={`https://console.cloud.google.com/storage/browser/${row.original.path}`} title={`Direct link to the google storage link for ${row.original.name} service of ${row.original.group_name}`} />
                        : <div className='h-10 w-32 text-gray-500 border border-gray-400 rounded text-xs m-auto flex'>
                            <div className='pt-2 pl-2'><Spinner /></div>
                            <div className='m-auto cursor-default'>Exporting...</div>
                        </div>
                }</>)
            },
            {
                Header: "Deploy",
                accessor: "deployment",
                Cell: ({ row }) => (<>{
                    row.original.status === 1 ?
                        <DirectLink path={`${process.env.REACT_APP_BIZ_DOMAIN}/models?service_id=${row.original.id}`} title={`Direct link for the model deployment`} />
                        : <div className='h-10 w-32 text-gray-500 border border-gray-400 rounded text-xs m-auto flex'>
                            <div className='pt-2 pl-2'><Spinner /></div>
                            <div className='m-auto cursor-default'>Exporting...</div>
                        </div>
                }</>)
            },
            {
                Header: "Model",
                accessor: "general_model.name",
                Cell: ({ row }) => (
                    <div className="flex items-center justify-center gap-2">
                        <span>{row.original.general_model.name}</span>
                        <DirectLink
                            path={`/post-action/models/${row.original.general_model.id}`}
                            title={`Go to the post action page of ${row.original.general_model.name}`}
                        />
                    </div>
                ),
            },
            {
                Header: "Database",
                accessor: "general_model.database_version",
                Filter: SelectColumnFilter,
                filter: 'exactTo'
            },
            {
                Header: "Model Type",
                accessor: "model_type_col",
                Cell: ({ row }) => <div>{row.original.model_type.join(", ")}</div>
            },
            {
                Header: "Converted Model",
                accessor: "converted_model.name",
                Cell: ({ row }) => (
                    <div>
                        <div>{row.original.converted_model.name}</div>
                        {row.original.fe_variants?.length > 1 &&
                            <span className={`mt-1 inline-block rounded text-xs font-semibold px-1.5 py-0.5 ${row.original.fe_variant === 'stft' ? 'bg-blue-100 text-blue-700' : 'bg-emerald-100 text-emerald-700'}`}>
                                {row.original.fe_variant === 'stft' ? 'STFT' : 'Conv1d'}
                            </span>}
                    </div>
                ),
            },
            {
                Header: "Threshold",
                accessor: "threshold.name",
            },
        ], []
    )

    return (
        <Table data={data} columns={columns} />
    )
}

export default ServiceArchiveTable